export default __webpack_public_path__ + "static/media/MasterKYRHK_HKVO_HKSub.e6db714e.mp4";